export interface IPrice {
  currency: ECurrency;
  value: number;
  period?: EPeriod | null;
}

export enum ECurrency {
  Eur = 'eur',
  Rur = 'rur',
  Usd = 'usd',
}

export enum EPeriod {
  Day = 'day',
  Month = 'month',
}
